import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";

export const inr = (n) => (n == null ? "—" : `₹${Number(n).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`);

/** CREATE QUOTE — builds the Smart Format quotation line and hands it to the existing New Quotation flow. */
export function useQuoteNav() {
  const nav = useNavigate();
  return async (payload) => {
    try {
      const { data } = await api.post("/apple-cto/quote-item", payload);
      sessionStorage.setItem("st:quote-prefill", JSON.stringify({ items: data.items, subject: data.subject }));
      nav("/commercial/crm/quotations?new=1&prefill=1");
    } catch (e) {
      const d = e.response?.data?.detail;
      toast.error(d?.message || d || "Could not create quotation item", { duration: 8000 });
    }
  };
}
